<svg
  class="radio"
  [class.checked]="checked"
  [class.disabled]="disabled"
  width="14"
  height="14"
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg">
  <circle cx="7" cy="7" r="6.5" stroke="currentColor" />

  <circle class="inner" cx="7" cy="7" r="3.5" fill="currentColor" stroke="currentColor" />
</svg>
